import type { PropsWithChildren } from 'react';

import { Navigation } from '@drycut/navigation';
import { useDocumentTitle } from 'usehooks-ts';

import { Button } from '../Button';
import { CenteredSquaredContainer } from '../CenteredSquaredContainer';
import { FullscreenImageLayout } from '../FullscreenImageLayout';
import background from '../images/error-background.jpg';
import { Stack } from '../Stack';

type Props = PropsWithChildren<{
  title: string;
}>;

export function ErrorPageContainer({ title, children }: Props): React.ReactElement {
  useDocumentTitle(title);

  return (
    <main>
      <FullscreenImageLayout src={background} logoClasses="block">
        <CenteredSquaredContainer className="pt-52 lg:pt-8">
          <Stack className="antialiased" gap={10}>
            <div className="text-pretty">{children}</div>

            <Button as="a" color="primary" className="w-56" href={Navigation.HOME_URL}>
              Zur Startseite
            </Button>
          </Stack>
        </CenteredSquaredContainer>
      </FullscreenImageLayout>
    </main>
  );
}
